import { useMutation } from '@tanstack/react-query';

import { useAccountsClient } from 'services/api';
import { MarkUnsupportedDeviceDocument } from 'types/api/account.types';

export const useMarkUnsupportedDevice = () => {
  const accountClient = useAccountsClient();
  const mutation = useMutation({
    mutationFn: () => accountClient.request(MarkUnsupportedDeviceDocument),
  });

  return {
    markUnsupportedDevice: mutation.mutate,
    isLoading: mutation.isPending && !mutation.isPaused,
    isError: mutation.isError,
  };
};
